var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLeftHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 687,
    height: 100,
    viewBox: "0 0 687 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M613.82 0H20C10.5719 0 5.85786 0 2.92893 2.92893C0 5.85786 0 10.5719 0 20V80C0 89.4281 0 94.1421 2.92893 97.0711C5.85786 100 10.5719 100 20 100H650.72C666.558 100 674.477 100 677.339 94.8792C680.201 89.7585 676.053 83.0133 667.757 69.5228L630.857 9.5228C627.995 4.86912 626.563 2.54228 624.289 1.27114C622.015 0 619.284 0 613.82 0Z",
    fill: "white",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M582 0.5L606.384 0.788177C615.162 0.891927 619.551 0.943802 623.249 2.9494C626.947 4.955 629.384 8.60574 634.259 15.9072L643 29",
    stroke: "#232934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeftHex);
export default __webpack_public_path__ + "static/media/bottomLeftHex.180aac2518e3ca2bde283c472f4114fa.svg";
export { ForwardRef as ReactComponent };